/* eslint-disable no-undef */
import { $$ } from 'utils/dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { fadeInFromBottom } from '../animations';
import { viewport } from '../getViewport';

export const storyImageText = () => {
  const sections = $$('.story-image-text');

  if (sections.length) {
    sections.forEach(section => {
      const textElements = $$('.story-image-text__content-inner', section);
      fadeInFromBottom(textElements, section);

      textElements.forEach(text => {
        gsap.set(text, {
          yPercent: viewport.isDesktop
            ? '20'
            : viewport.isTablet
            ? '20'
            : viewport.isMobile
            ? '0'
            : '',
        });
        const timeline = gsap.timeline();

        timeline.to(text, {
          yPercent: viewport.isDesktop
            ? '-80'
            : viewport.isTablet
            ? '-80'
            : viewport.isMobile
            ? '0'
            : '',
        });

        ScrollTrigger.create({
          animation: timeline,
          trigger: section,
          start: () => 'top center',
          end: () => 'bottom 10%',
          toggleActions: 'play pause resume reset',
          scrub: 1,
        });
      });
    });
  }
};
